import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer bg-dark text-light position-relative">
      {/* Main Footer Section */}
      <div className="container py-5">
        <div className="row g-5">
          {/* Brand Column */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand mb-4">
              <Link to="/" className="d-flex align-items-center mb-4">
                <img
                  src="/images/white-logo.png"
                  height="45"
                  alt="Formax Pay"
                  className="me-2"
                />
              </Link>
              <p className="text-light opacity-75 mb-4">
                A leading technology service provider powering India's digital
                payment ecosystem through secure, scalable, and compliant API
                solutions. We partner with regulated banks and financial
                institutions to deliver cutting-edge fintech infrastructure.
              </p>

              {/* Social Icons - Updated with square boxes */}
              <div className="social-links">
                <h6 className="text-white mb-3">Connect With Us</h6>
                <div className="d-flex gap-2">
                  <a
                    href="https://x.com/formax_it"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon bg-secondary rounded d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                    title="Twitter"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/formax-pay"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon bg-secondary rounded d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                    title="LinkedIn"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/formaxitsolutions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon bg-secondary rounded d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/formaxpay/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon bg-secondary rounded d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                    title="Instagram"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Products Column */}
          <div className="col-lg-2 col-md-6">
            <h5 className="text-white fw-bold mb-4">Products</h5>
            <ul className="list-unstyled">
              <li className="mb-3">
                <Link
                  to="/recharge-and-bill-payment"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Recharge & BBPS Platform
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to="/pan-card-services"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  E-Governance Services
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to="/insurance-posp"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Insurance POSP Platform
                </Link>
              </li>
              {/* <li className="mb-3">
                <Link
                  to="/lead-generation"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Lead Generation Platform
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Solutions Column */}
          <div className="col-lg-2 col-md-6">
            <h5 className="text-white fw-bold mb-4">Solutions</h5>
            <ul className="list-unstyled">
              <li className="mb-3">
                <Link
                  to=""
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Retail & MSME
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to=""
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Startups & SaaS
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to=""
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Fintech & NBFCs
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to=""
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Enterprise
                </Link>
              </li>
            </ul>
          </div>

          {/* APIs Column */}
          <div className="col-lg-2 col-md-6">
            <h5 className="text-white fw-bold mb-4">APIs</h5>
            <ul className="list-unstyled">
              <li className="mb-3">
                <a
                  href="https://developers.formaxpay.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  API Documentation
                </a>
              </li>
              <li className="mb-3">
                <a
                  href="https://developers.formaxpay.com/bill-payment-api-6015312f0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Bill Payment API
                </a>
              </li>
              <li className="mb-3">
                <a
                  href="https://developers.formaxpay.com/recharge-api-6015309f0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Recharge API
                </a>
              </li>
              <li className="mb-3">
                <a
                  href="https://developers.formaxpay.com/insurance-posp-api-6015331f0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Insurance POSP API
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="col-lg-2 col-md-6">
            <h5 className="text-white fw-bold mb-4">Company</h5>
            <ul className="list-unstyled">
              <li className="mb-3">
                <Link
                  to="/about-formax-pay"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  About Us
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to="/contact-us"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Contact Us
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to="/compliance-and-security"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Compliance & Security
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  to="/grievance-policy"
                  className="text-light opacity-75 text-decoration-none d-flex align-items-center hover-effect"
                >
                  <i className="fas fa-angle-right text-primary me-2"></i>
                  Grievance Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Important Notice */}
        <div className="notice-card bg-dark border border-secondary rounded p-3 mb-4">
          <p className="small text-light opacity-75 mb-0">
            <i className="fas fa-info-circle text-primary me-1"></i>
            <strong className="text-white">Important:</strong> Formax Pay is a
            technology service provider partnered with regulated banks and
            financial institutions. We are not a bank. All financial services
            are provided by our partner institutions under their respective
            regulatory frameworks.
          </p>
        </div>

        {/* Horizontal Divider */}
        <hr className="my-5 border-secondary" />

        {/* Contact Info Row - Updated with fully rounded icons */}
        <div className="row text-center">
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="d-flex flex-column align-items-center">
              <div className="icon-wrapper mb-3">
                <div
                  className="bg-primary bg-opacity-25 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-phone-alt text-white fa-lg"></i>
                </div>
              </div>
              <h6 className="text-white fw-bold mb-2">Customer Support</h6>
              <p className="text-light opacity-75 small mb-2">
                WhatsApp support for quick assistance
              </p>
              <a
                href="https://api.whatsapp.com/send/?phone=917890090500&text=Hello, I have need some help!"
                target="_blank"
                className="text-white fw-bold"
              >
                +91 78900 90500 (Whatsapp)
              </a>
            </div>
          </div>

          <div className="col-md-4 mb-4 mb-md-0">
            <div className="d-flex flex-column align-items-center">
              <div className="icon-wrapper mb-3">
                <div
                  className="bg-primary bg-opacity-25 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-envelope text-white fa-lg"></i>
                </div>
              </div>
              <h6 className="text-white fw-bold mb-2">Developer Support</h6>
              <p className="text-light opacity-75 small mb-2">
                API Documentation & Integration
              </p>
              <a
                href="https://api.whatsapp.com/send/?phone=919836114520&text=Hello, I have need some help!"
                target="_blank"
                className="text-white fw-bold"
              >
                +91 9836114520
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <div className="d-flex flex-column align-items-center">
              <div className="icon-wrapper mb-3">
                <div
                  className="bg-primary bg-opacity-25 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                  }}
                >
                  <i className="fas fa-map-marker-alt text-white fa-lg"></i>
                </div>
              </div>
              <h6 className="text-white fw-bold mb-2">Headquarters</h6>
              <p className="text-light opacity-75 small mb-2">
                Formax IT Solutions Pvt Ltd
              </p>
              <div className="text-white">Kolkata, West Bengal</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom py-4 border-top border-secondary bg-dark">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-5 mb-3 mb-md-0">
              <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
                <p className="text-light opacity-75 mb-2 mb-md-0 me-md-3">
                  © {currentYear} Formax IT Solutions Private Limited.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-7">
              <div className="text-center text-md-end">
                <ul className="list-inline mb-0">
                  <li className="list-inline-item me-3">
                    <Link
                      to="/privacy-policy"
                      className="text-light opacity-75 text-decoration-none"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="list-inline-item me-3">
                    <Link
                      to="/terms-and-conditions"
                      className="text-light opacity-75 text-decoration-none"
                    >
                      Terms & Conditions
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="/refund-policy"
                      className="text-light opacity-75 text-decoration-none"
                    >
                      Refund Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
